import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { CHINA_LANGUAGE_CODE, RUSSIA_LANGUAGE_CODE } from './constants'
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    supportedLngs: [RUSSIA_LANGUAGE_CODE, CHINA_LANGUAGE_CODE],
    fallbackLng: RUSSIA_LANGUAGE_CODE,
    detection: {
      order: ['cookie', 'htmlTag', 'path', 'localStorage', 'subdomain'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/static/locales/{{lng}}/translation.json',
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
